import { ReactNode } from 'react';

import { Box, Grid, List, Typography } from '@mui/material';

import { TransactionItem as TransactionMonthBlockInterface } from '@clients/transactionsClient';
import TransactionItem from '@pages/transactions/TransactionItem';

export interface TransactionMonthBlockProp {
    transactions: TransactionMonthBlockInterface[];
    heading: ReactNode;
    id: string;
}

const TransactionMonthBlock = ({
    transactions,
    heading,
}: TransactionMonthBlockProp) => (
    <Grid item xs={12} sx={{ mt: 3, mb: 3 }}>
        <Typography variant="overline">{heading}</Typography>
        <Box
            sx={{
                mt: 2,
                bgcolor: 'background.paper',
                width: '100%',
            }}>
            <List>
                {transactions.map((transactionItem) => {
                    return (
                        <TransactionItem
                            key={`transaction-item-${transactionItem?.id}`}
                            transaction={transactionItem}
                        />
                    );
                })}
            </List>
        </Box>
    </Grid>
);
export default TransactionMonthBlock;
